import { render, staticRenderFns } from "./DownLoadDia.vue?vue&type=template&id=b56e44bc&"
import script from "./DownLoadDia.vue?vue&type=script&lang=ts&"
export * from "./DownLoadDia.vue?vue&type=script&lang=ts&"
import style0 from "./DownLoadDia.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports